import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser'; 
import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';
import { MyApp } from './app.component';

/* --- PAGES --- */
import { AboutPage } from '../pages/about/about';
import { CollectiblesPage } from '../pages/collectibles/collectibles';
import { HomePage } from '../pages/home/home';
import { SettingsPage } from '../pages/settings/settings';
import { GamemodesPage } from '../pages/gamemodes/gamemodes';
import { VersusAIPage } from '../pages/versusai/versusai';
import { VersusPVPAsyncPage } from '../pages/versuspvpasync/versuspvpasync';
import { VersusPVPsyncPage } from '../pages/versuspvpsync/versuspvpsync';
import { SurveyPage } from '../pages/survey/survey';
import { PlayPage } from '../pages/play/play';
import { EndgamePage } from '../pages/endgame/endgame'; 
import { LoginPage } from '../pages/login/login';
import { LostPasswordPage } from '../pages/lostpassword/lostpassword';
import { RegisterPage } from '../pages/register/register';
import { DisclaimerPage } from '../pages/disclaimer/disclaimer';
import { HowToPage } from '../pages/howto/howto';
import { IntroPage } from '../pages/intro/intro';
import { ProfilePage } from '../pages/profile/profile';
import { RankingsPage } from '../pages/rankings/rankings';
import { ReadstoryPage } from '../pages/readstory/readstory';
import { WorkInProgressPage } from '../pages/workinprogress/workinprogress';

import { CollectiblesRewardPage } from '../pages/collectiblesreward/collectiblesreward';


import { HttpModule } from "@angular/http";
import { Http } from '@angular/http';

import { Storage } from '@ionic/storage';
import { SQLite/*, SQLiteObject*/ } from '@ionic-native/sqlite';
import { IonicStorageModule } from '@ionic/storage';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { NativeAudio } from '@ionic-native/native-audio';

// CUSTOM SERVICES
import { Functions } from '../providers/functions';
import { DataExchanger } from '../providers/data-exchanger';
import { Auth } from '../providers/auth';
import { ConnectivityService } from '../providers/connectivity-service';
import { SmartAudio } from '../providers/smart-audio';

import { GameModel } from '../providers/game-model';
import { GamerulesModel } from '../providers/gamerules-model';
import { UserdataModel } from '../providers/userdata-model';

import { ProgressBarComponent } from '../components/progress-bar/progress-bar';
import { ThermometerBarComponent } from '../components/thermometer-bar/thermometer-bar';


export function createTranslateLoader(http: Http) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}


@NgModule({
  declarations: [
    MyApp,
    AboutPage,
    CollectiblesPage,
    HomePage,
    SettingsPage,
    GamemodesPage,
    VersusAIPage,
    VersusPVPAsyncPage,
    VersusPVPsyncPage,
    SurveyPage,
    PlayPage,
    EndgamePage,
    LoginPage,
    LostPasswordPage,
    RegisterPage,
    DisclaimerPage,
    HowToPage,
    IntroPage,
    ProfilePage,
    RankingsPage,
    ReadstoryPage,
    WorkInProgressPage,
    CollectiblesRewardPage,
    ProgressBarComponent,
    ThermometerBarComponent
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(MyApp),
    IonicStorageModule.forRoot(),
    HttpModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [Http]
      }
    })
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    AboutPage,
    CollectiblesPage,
    HomePage,
    SettingsPage,
    GamemodesPage,
    VersusAIPage,
    VersusPVPAsyncPage,
    VersusPVPsyncPage,
    SurveyPage,
    PlayPage,
    EndgamePage,
    LoginPage,
    LostPasswordPage,
    RegisterPage,
    DisclaimerPage,
    HowToPage,
    IntroPage,
    ProfilePage,
    RankingsPage,
    ReadstoryPage,
    WorkInProgressPage,
    CollectiblesRewardPage    
  ],
  providers: [
    StatusBar,
    SplashScreen,
    SQLite, 
    Functions,
    DataExchanger,
    Auth,
    ConnectivityService,
    SmartAudio,
    NativeAudio,
    GameModel,
    GamerulesModel,
    UserdataModel,
    ThermometerBarComponent,
    {provide: ErrorHandler, useClass: IonicErrorHandler}
  ]
})
export class AppModule {

  constructor(private storage: Storage, public functions:Functions) {
    this.functions.setSocket();
  }
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts